import $ from "jquery";

const megaMenu = () => {
  const init = () => {
    openMegaMenu();
    openMenuChild();
  };

  const openMegaMenu = () => {
    $(function () {
      $(".open-mega-menu a").on("click", function () {
        $(".sec-mega-menu").toggleClass("show");
        $(this).toggleClass("arrow-up");
      });
    });
  };

  const openMenuChild = () => {
    $(function () {
      $(".sec-mega-menu .header-nav li.menu-item-has-children > a").on(
        "click",
        function (event) {
          event.preventDefault();

          var $submenu = $(this).siblings("ul.sub-menu");
          $submenu.toggleClass("show");
          $(this).parent().toggleClass("arrow-up");

          // Menutup submenu lainnya jika ada
          $(".sec-mega-menu .header-nav li.menu-item-has-children > a")
            .not(this)
            .siblings("ul.sub-menu")
            .removeClass("show");
        }
      );
    });
  };

  init();
};

try {
  megaMenu();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
